import { Route } from '../types/api';
import { mapPortToLocation } from './mapPortToLocation';

export const mapRoutesWithStatusToLocation = ((item: Route) => item
  .ports
  .filter((port) => !port.isFreight && !port.hideOnMap)
  .map(mapPortToLocation)
  .flat());
